import React from 'react';
import PropTypes from 'prop-types';
import styles from "./AirportRadioInput.module.scss";
import RadioBtn from "../../../../../Common/RadioBtn/RadioBtn";

const AirportRadioInput = ({onSelect, checked, disabled, children, ...props}) => {

    const containerClasses = [styles.inputRadioContainer];
    if (disabled) {
        containerClasses.push(styles.disabled);
    }

    return (
        <div className={containerClasses.join(' ')} onClick={!disabled ? onSelect : null}>
            <RadioBtn
                btnContainerOverrideClasses={[styles.inputRadio]}
                btnDotOverrideClasses={[styles.inputRadioDotInside]}
                checked={checked}/>{children}
        </div>
    );
};

AirportRadioInput.propTypes = {
    children: PropTypes.any,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
};

AirportRadioInput.defaultProps = {
    children: null,
    checked: false,
    disabled: false,
    onSelect: () => null,
};

export default AirportRadioInput;